import bannerImage from "/public/banner.jpg"; // Or move to src/assets and adjust
// path
import { Image } from "@heroui/image";
import logo from "/public/logo.png";
import { Award, Landmark, Shield, Verified } from "lucide-react";
import { useGetRandomFourAnimals } from "@/features/Admin/Admin.api.ts";
import AnimalCard from "@/components/animal-card.tsx";
import { FormValues } from "@/models/Sila.Animals.schema.ts";
import { Separator } from "@/features/ui/Separator.tsx";

const Banner = () => {
  return (
    <main className=" w-screen h-full flex flex-col items-center justify-center bg-center bg-cover overflow-y-auto font-['suse'] pb-10">
      <header className="w-full flex flex-row  justify-between px-4 items-center">
        <img alt="Logo" className="lg:h-12 h-6 z-20 " src={logo} />
        <h1 className="text-2xl lg:block hidden font-medium">
          Silagreen Genetics
        </h1>
      </header>
      <div className="w-full h-full relative">
        <Image
          loading={"eager"}
          src={bannerImage}
          alt="Banner Image"
          className="w-screen h-[600px] object-cover rounded-none z-"
          style={{
            filter: "brightness(0.5)",
          }}
        />
        <div className="absolute inset-0 top-[200px] flex flex-col gap-10 items-center justify-center bg-transparent  text-4xl font-medium [text-shadow:_0_2px_4px_rgb(0_0_0_/_50%)] z-50">
          <span className="text-yellow-500 lg:w-[600px] font-bold text-lg text-wrap lg:text-4xl text-center items-center text-">
            Superior Genetics For Exceptional Livestock
          </span>
          <span className="text-gray-50 lg:w-[600px] text-center text-wrap font-medium items-center text-base ">
            Elevate your livestock breeding programs with Silagreen Genetics
            Superior genetics. We provide premium semen and embryos,
            meticulously sourced from certified farms to guarantee exceptional
            quality and maximize your herd's potential.
          </span>
        </div>
      </div>
      <div className="w-full flex flex-col items-center justify-center gap-8 bg-slate-100">
        <div className="flex flex-col items-center justify-center gap-2 p-6">
          <h2 className="text-xl font-bold text-[#008c8fff]">
            Trusted by industry leaders and government entities
          </h2>
        </div>
        <div className="flex flex-col lg:flex-row gap-4 items-start justify-center">
          <div className="w-[200px] flex flex-col gap-4 items-center justify-center">
            <Landmark
              className="bg-gray-200 text-blue-400 p-2 rounded-full"
              size={45}
            />
            <h5 className="text-gray-500 font-semibold">Government Approved</h5>
            <span className="text-center text-slate-400">
              Our products strictly comply with all government regulations and
              quality control standards.
            </span>
          </div>
          <div className="w-[200px] flex flex-col gap-4 items-center justify-center">
            <Award
              className="bg-gray-200 text-amber-400 p-2 rounded-full"
              size={45}
            />
            <h5 className="text-gray-500 font-semibold">Industry Certified</h5>
            <span className="text-center text-slate-400">
              All genetic material meets international breeding standards
            </span>
          </div>
          <div className="w-[200px] flex flex-col gap-4 items-center justify-center">
            <Shield
              className="bg-gray-200 text-amber-400 p-2 rounded-full"
              size={45}
            />
            <h5 className="text-gray-500 font-semibold">Industry Certified</h5>
            <span className="text-center text-slate-400">
              Rigorous testing and verification processes
            </span>
          </div>
          <div className="w-[200px] flex flex-col gap-4 items-center justify-center">
            <Verified
              className="bg-gray-200 text-green-600 p-2 rounded-full"
              size={45}
            />
            <h5 className="text-gray-500 font-semibold">Verified Farms</h5>
            <span className="text-center text-slate-400">
              Partner with authenticated and licensed farms
            </span>
          </div>
        </div>
      </div>
      <div className={"w-full"}>
        <FeaturedSection />
      </div>
    </main>
  );
};

const FeaturedSection = () => {
  const { data } = useGetRandomFourAnimals();

  return (
    <div
      className={
        "w-full flex flex-col items-center justify-center overflow-hidden py-10" +
        "lg:px-20 px-0 text-center lg:text-start"
      }
    >
      <h5 className={"font-bold text-xl text-[#008c8fff]"}>
        Featured Superior Genetics
      </h5>
      <span className={"text-medium font-medium"}>
        Handpicked premium breeds for your breeding program
      </span>
      <div
        className={
          "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-6" +
          " mt-6 px-0"
        }
      >
        {data &&
          data.map((animal: FormValues) => (
            <AnimalCard
              key={animal.dgr}
              animal={animal}
              className="animal-card w-full"
            />
          ))}
      </div>
      <Separator />
    </div>
  );
};

export default Banner;
